import { cyan, orange, pink, purple, red, green } from "@mui/material/colors";

const kolorki = [red, pink, purple, cyan, green, orange];

export { kolorki };